import './DiscountSkeleton.scss';

const DiscountSkeleton = () => {

    return (
        <div className="discount__wrapper__section__skeleton">
            <div className='discount__wrapper__section__top__skeleton'>
                <div className="discount__wrapper__section__desc__skeleton">
                    <div className="discount__wrapper__section__desc__title__skeleton"></div>
                    {[...Array(6)].map((_, index) => (
                        <div key={index} className="discount__wrapper__section__desc__subtitle__skeleton"></div>
                    ))}
                    <div className="discount__wrapper__section__desc__subtitle__skeleton--primary"></div>
                </div>
                <div className="discount__wrapper__section__offers__skeleton">
                    {[...Array(2)].map((_, index) => (
                        <div key={index} className="discount__offer__skeleton">
                            <div className='sale__skeleton'></div>
                            <div className='discount__offer__link__wrapper__skeleton'>
                                <div className="discount__offer__link__skeleton"></div>
                                <div className="discount__offer__link__skeleton--primary"></div>
                                {[...Array(4)].map((_, index) => (
                                    <div key={index} className="discount__offer__text__skeleton"></div>
                                ))}
                                <div className="discount__offer__text__skeleton--primary"></div>
                            </div>
                            <div className="discount__offer__button__skeleton"></div>
                        </div>
                    ))}
                </div>
            </div>

            <div className='offers__wrapper__section__bottom__skeleton'>
                <div className="offers__wrapper__section__desc__skeleton">
                    <div className="offers__wrapper__section__desc__title__skeleton"></div>
                    <div className="offers__wrapper__section__desc__subtitle__skeleton"></div>
                    <div className="offers__wrapper__section__desc__subtitle__skeleton--primary"></div>
                </div>
                <div className="offers__wrapper__section__offers__skeleton">
                    {[...Array(6)].map((_, index) => (
                        <div key={index} className="offers__offer__skeleton">
                            <div className='sale__skeleton'></div>
                            <div className='offers__offer__link__wrapper__skeleton'>
                                <div className="offers__offer__link__skeleton"></div>
                                <div className="offers__offer__link__skeleton--primary"></div>
                                {[...Array(4)].map((_, index) => (
                                    <div key={index} className="offers__offer__text__skeleton"></div>
                                ))}
                                <div className="offers__offer__text__skeleton--primary"></div>
                            </div>
                            <div className="offers__offer__button__skeleton"></div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DiscountSkeleton;